import { required, minLength, maxLength } from "react-admin";

export const validateValue = [required(), minLength(2), maxLength(100)];
